import React, { useState } from 'react';

const Acordion = ({ defaultOpenIndex, children }) => {
  const [openIndex, setOpenIndex] = useState(defaultOpenIndex);

  // Asegura que los children sean un array para poder mapearlos
  const items = React.Children.toArray(children).filter(React.isValidElement);

  return (
    // Creamos un contexto de apilamiento para el acordeón
    <div style={{ position: 'relative', zIndex: 1 }}>
      {items.map((child, index) => {
        return React.cloneElement(child, {
          key: index,
          isOpen: index === openIndex,
          onClick: () => setOpenIndex(index === openIndex ? -1 : index),
        });
      })}
    </div>
  );
};

export default Acordion;